import React, { useState } from 'react';
import { IpaType } from '../../phonemes/ipa';
import { Rule } from '../../rules/rule';
import { en_US_ipa, en_US_segments } from '../../transcribe/en_US.json';
import { worldAllophones } from '../../transmogrify/allophones';
import { makeTransmogrification } from '../../transmogrify/makeTransmogrification';
import { getLanguageTrackers } from '../LanguageTrackers';
import { ChoiceList } from '../widgets/ChoiceList';
import { IpaKeyboard } from '../widgets/IpaKeyboard';

interface RulesFromSegmentsProps {
  /** list of languages to display */
  readonly allLanguages: string[];
  /** notify parent of new rules */
  readonly setRules: (rules: Rule[]) => void;
}

/**
 * control that lets you to type in phoneme segments,
 * which then turns it into rules that transform en-US phonemes
 * into the specified phoneme segments
 */
export function RulesFromSegments(props: RulesFromSegmentsProps) {
  const [segmentText, setSegmentText] = useState('');
  const [currentLanguage, setCurrentLanguage] = useState('');

  function makeRules() {
    const segments = segmentText.split(/ |\n/);
    const ipa = justIpa(segments);
    const { rules } = makeTransmogrification(en_US_ipa, en_US_segments, ipa, segments, worldAllophones);
    props.setRules(rules);
  }

  function pickLanguage(language: string) {
    setCurrentLanguage(language);
    const segments = getLanguageTrackers().lookupStats(language).segments;
    setSegmentText(segments);
  }

  return (<>
    <button onClick={() => makeRules()}>make rules from segments</button>
    <br />
    <IpaKeyboard cols={80} rows={4} value={segmentText} onChange={setSegmentText} />
    <br />
    see segments from:&nbsp;
    <ChoiceList items={props.allLanguages} selectedItem={currentLanguage} onSelect={pickLanguage} />
  </>);
}

function justIpa(segments: IpaType[]): IpaType[] {
  const set: Set<IpaType> = new Set();
  segments.forEach(segment => {
    for (let i = 0; i < segment.length; i++) {
      set.add(segment[i]);
    }
  });

  const array: IpaType[] = [];
  set.forEach(v => array.push(v));
  return array;
}
